import React from 'react';

import { Skeleton, Typography } from 'lighthouse';

import Badge from '@/widgets/Badge';
import { StarRating } from '@/widgets/StarRating';

import { calculateSatisfaction } from '@/utilities/calculateSatisfaction';
import { withSeparator } from '@/utilities/withSeparator';

import { ProductMetaProps } from './models';

export const ProductMeta = ({
    subtitle,
    ratingSummary,
    available,
    availableQuantity = 0,
    isPriceLoading,
    isRatingLoading,
    onAddReview,
    canAddReview,
    badges,
    onReviewsClick
}: ProductMetaProps) => {
    const isLowStock = available && availableQuantity > 0 && availableQuantity <= 3;
    const stockColor = isLowStock ? 'error' : 'success';
    const ratingLabel = ratingSummary ? `امتیاز ${ratingSummary.average.toFixed(1)} از ۵` : 'ثبت دیدگاه';
    const stockLabel = isLowStock ? `تنها ${withSeparator(availableQuantity)} عدد باقی مانده` : 'موجود';

    return (
        <div className='flex flex-col gap-3'>
            {!!badges?.length && (
                <div className='flex flex-wrap items-center gap-1.5'>
                    {badges.map((badge, index) => (
                        <Badge key={index} isRounded color={badge.color} label={badge.title} icon={badge.icon} size='medium' />
                    ))}
                </div>
            )}
            {!!subtitle && (
                <Typography variant='caption' color='blackMediumEmphasis' component='p'>
                    {subtitle}
                </Typography>
            )}

            <div className='flex flex-col gap-1.5'>
                <div className='flex flex-wrap items-center gap-x-2 gap-y-1.5'>
                    {isRatingLoading ? (
                        <span className='flex items-center gap-1.5'>
                            <Skeleton variant='rectangular' width={72} height={14} className='rounded' />
                            <Skeleton variant='rectangular' width={28} height={14} className='rounded' />
                            <Skeleton variant='rectangular' width={64} height={14} className='rounded' />
                        </span>
                    ) : ratingSummary ? (
                        <a href='#reviews' className='flex items-center gap-1.5' aria-label={ratingLabel} onClick={onReviewsClick}>
                            <StarRating size='sm' rating={ratingSummary.average} />
                            <Typography
                                variant='caption'
                                fontWeight={700}
                                className={calculateSatisfaction(ratingSummary.average, ratingSummary.count).textClassName}>
                                {ratingSummary.average.toFixed(1)}
                            </Typography>
                            <Typography variant='caption' color='primary'>
                                ({withSeparator(ratingSummary.count)} دیدگاه)
                            </Typography>
                        </a>
                    ) : canAddReview ? (
                        <button
                            type='button'
                            className='flex cursor-pointer items-center gap-1.5 border-0 bg-transparent p-0'
                            aria-label={ratingLabel}
                            onClick={onAddReview}>
                            <Typography variant='caption' color='primary'>
                                اولین دیدگاه را ثبت کنید
                            </Typography>
                        </button>
                    ) : null}
                </div>
            </div>

            {isPriceLoading ? (
                <Skeleton variant='rectangular' width={72} height={16} className='rounded' />
            ) : available ? (
                <Typography variant='caption' color={stockColor} fontWeight={600}>
                    {stockLabel}
                </Typography>
            ) : null}
        </div>
    );
};
